import { UPLOAD_PREFIXES, uploadPublicImage } from '@/services/s3';
import { v4 as uuidv4 } from 'uuid';

/**
 * Uploads a picked menu image to the shared public bucket and resolves to its
 * URL. The image lands under the same `menu_images` prefix every menu-image
 * order guide flow uses, so the backend can read it back when extracting items.
 *
 * Wraps the shared S3 service so the upload boundary stays in one place: the
 * file is exposed to the uploader as an object URL (read back over XHR) and the
 * URL is revoked once the upload settles, whether it succeeds or fails.
 *
 * @param file - The image file selected from the browser file picker
 * @returns The public URL of the uploaded image
 */
export const uploadMenuImage = (file: File): Promise<string> => {
  const objectUrl = URL.createObjectURL(file);
  return uploadPublicImage(
    uuidv4(),
    objectUrl,
    UPLOAD_PREFIXES.MenuImages,
  ).finally(() => URL.revokeObjectURL(objectUrl));
};
